import { render, staticRenderFns } from "./ScoreButton.vue?vue&type=template&id=1edfbeed&scoped=true&"
import script from "./ScoreButton.ts?vue&type=script&lang=ts&"
export * from "./ScoreButton.ts?vue&type=script&lang=ts&"
import style0 from "./ScoreButton.css?vue&type=style&index=0&id=1edfbeed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edfbeed",
  null
  
)

export default component.exports